// import Conference from './components';
import conferenceReducer from './reducers';

export { conferenceReducer };
